import { toast } from "react-toastify";
import { datadogRum } from "@datadog/browser-rum";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { hasCookiePermission } from "../layout/cookies/CookieFunctions";

const IS_DEV = getEnvironmentVariable("IS_DEV") === "true";

export function postNotification(toastType, toastMessage, ignoreDatadog) {
  var message =
    typeof toastMessage === "object"
      ? toastMessage.response?.data?.errorMessage ||
        toastMessage.response?.data?.error ||
        toastMessage.response?.data ||
        toastMessage.message ||
        toastMessage
      : toastMessage;
  if (toastType === "info") {
    toast.info(message);
  } else if (toastType === "success") {
    toast.success(message);
  } else if (toastType === "warning") {
    toast.warning(message);
  } else if (toastType === "error") {
    toast.error(message);

    if (!ignoreDatadog && typeof toastMessage === "object" && !IS_DEV) {
      const isClientSideError =
        toastMessage?.response?.status >= 400 &&
        toastMessage?.response?.status < 500;

      // Don't log client-side API errors to DataDog
      if (!isClientSideError) {
        if (hasCookiePermission("dataDog") && datadogRum?.addError) {
          datadogRum.addError(toastMessage);
        }
      }
    }
  } else if (toastType === "dark") {
    toast.dark(message);
  } else {
    toast(message);
  }
}
